
export function sayHello() {
    console.log("Hello, World!");
}

//sayHello();